import React from "react";

const CookieUse: React.FC = () => {
  return (
    <div>
      <div className="p-4 md:px-[15vw] md:pt-[5vh] w-full flex flex-col font-normal text-sm space-y-5 text-black">
        <div>
          {/* <p className="flex items-start text-[1.65vh] text-customGrayBase">
            Last modified: 10/22/2024
          </p> */}
          <h1 className="mt-[4%] font-helveticaBold text-[5.5vh] xxl:text-[7.5vh] leading-none text-black">
            Afrocart Cookie <br /> Use Policy
          </h1>
        </div>
        <p>
          At <span className="font-helveticaBold">Afrocart</span>, we believe in
          being clear about how we use cookies and similar technologies. This
          Cookie Use Policy explains what cookies are, how we use them, and your
          choices regarding their usage when you visit our website.
        </p>
        <ol className="decimal_ol space-y-4">
          <li className="font-helveticaBold text-black">
            What Are Cookies?
            <p className="font-helvetica text-black">
              Cookies are small text files that are stored on your device when
              you visit a website. They help websites remember your preferences,
              log-in details, and browsing activity, making your experience more
              seamless and personalized.
            </p>
          </li>

          <li className="font-helveticaBold text-black">
            How We Use Cookies
            <ul className="font-helvetica disc_li">
              We use cookies to:
              <li>Understand and save your preferences for future visits</li>
              <li>Provide a more personalized shopping experience</li>
              <li>Track website usage to improve our services</li>
              <li>Analyze trends and gather demographic information</li>
              <li>Remember items in your shopping cart</li>
            </ul>
          </li>
          <li className="font-helveticaBold text-black">
            Types of Cookies We Use
            <p className="font-helvetica text-black">
              We use both session cookies (which expire once you close your
              browser) and persistent cookies (which stay on your device until
              deleted) to provide you with a consistent experience on our
              website. The cookies we use may include essential, performance,
              functionality, and targeting cookies.
            </p>
          </li>
          <li className="font-helveticaBold text-black">
            Managing Cookies
            <p className="font-helvetica text-black">
              You have the option to accept or reject cookies through your
              browser settings. However, if you disable cookies, some features
              of our website may not function properly, and your experience may
              be affected.
            </p>
          </li>
          <li className="font-helveticaBold text-black">
            Third-Party Cookies
            <p className="font-helvetica text-black">
              We may allow third-party service providers to place cookies on
              your device to assist us in understanding website traffic and
              usage. These third-party cookies are subject to their respective
              privacy policies, not ours.
            </p>
          </li>
          <li className="font-helveticaBold text-black">
            Changes To This Cookie Use Policy
            <p className="font-helvetica text-black">
              We may update this Cookie Use Policy from time to time. Any
              changes will be posted on this page, and the updated date at the
              top will be revised to reflect the modifications.
            </p>
          </li>
          <li className="font-helveticaBold text-black">
            Contact Us
            <p className="font-helvetica text-black">
              If you have any questions about our Cookie Use Policy, please
              contact our customer service team.
            </p>
          </li>
        </ol>
      </div>
    </div>
  );
};

export default CookieUse;
